import { encodeCommunityURLData as c, encodeChannelURLData as r, encodeUserURLData as U } from "./encode-url-data.js";
const n = "https://status.app";
function u(t) {
  return new URL(`${n}/c#${t}`);
}
async function L(t, e) {
  const a = c(t);
  return new URL(`${n}/c/${a}#${e}`);
}
function R(t, e) {
  return new URL(`${n}/cc/${t}#${e}`);
}
async function i(t, e) {
  const a = r(t);
  return new URL(`${n}/cc/${a}#${e}`);
}
function $(t) {
  return new URL(`${n}/u#${t}`);
}
function h(t) {
  return new URL(`${n}/u#${t}`);
}
async function s(t, e) {
  const a = U(t);
  return new URL(`${n}/u/${a}#${e}`);
}
export {
  R as createChannelURLWithChatKey,
  i as createChannelURLWithData,
  u as createCommunityURLWithChatKey,
  L as createCommunityURLWithData,
  h as createUserURLWithChatKey,
  s as createUserURLWithData,
  $ as createUserURLWithENS
};
//# sourceMappingURL=create-url.js.map
